import axios from 'axios'
import util from './index'
const rules = {
    /* 基础信息校验 start*/
    socialCreditCode :[
        {required: true, message: ' ',trigger:'blur'}
    ],
    linkMan:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    linkManPost:[
        {required: true, message: '请输入职务',trigger:'blur'}
    ],
    linkPhone:[
        {required: true, message: '请输入联系电话',trigger:'blur'},
        { validator: 'regexp', pattern: /^[1][0-9][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'}
    ],
    recommender:[
        {required: true, message: '请输入推荐人',trigger:'blur'}
    ],
    headquartersAddress:[
        {required: true, message: '请输入办公地址',trigger:'blur'}
    ],
    companyEmail :[
        {required: true, message: '请输入公司邮箱',trigger:'blur'},
        { validator: 'regexp',pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,message:'邮箱格式不正确',trigger:'blur'}
    ],
    /* 基础信息校验 end*/
    /* 注册信息校验 start*/
    legalRepresentative:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    registeredCapital:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    enterpriseNature:[
        {required: true, message: ' ',trigger:'change'}
    ],
    businessLicenseValidity:[
        {required: true, message: ' ',trigger:'change'}
    ],
    businessLicenseStart:[
        {required: true, message: ' ',trigger:'change'}
    ],
    invoiceType:[
        {required: true, message: ' ',trigger:'change'}
    ],
    taxNumber:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    enterpriseRegistAddress:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    invoiceTaxRateList:[
        {required: true, message: ' ',trigger:'change'}
    ],
    taxipayerStatus:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    businessScope:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    /* 注册信息校验 end*/
    /* 供方分类 start*/
    categoryName:[
        {required: true, message: ' ',trigger:'change'}
    ],
    levelName:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    linkMan:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    linkManPhone:[
        {required: true, message: ' ',trigger:'blur'},
    ],
    /* 供方分类 end*/
    /* 近三年业绩 start*/
    projectName:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    contractAmount:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    projectAddress:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    contractSupplierName:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    /* 近三年业绩 end*/

    /* 近三年财务情况 start*/
    year:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    revenue:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    attachmentVOList:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    /* 近三年财务情况 end*/

    /* 银行信息 start*/
    country:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    accountName:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    bankAccount:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    openBank:[
        {required: true, message: ' ',trigger:'blur'}
    ],
    /* 银行信息 end*/
    /* 修改账号密码 start */
    passwordNew: [
        {required: true, message: '请输入新密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6}$/,message: '密码为6位数字和字母的组合', trigger: 'blur'}
    ],
    resetPasswordNew: [
        {required: true, message: '请输入确认新密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6}$/,message: '密码为6位数字和字母的组合', trigger: 'blur'}
    ],
    /* 修改账号密码 end */
    userName: [
        { required: true, message: '登录账号为手机号', trigger: 'blur'},
        { validator: 'regexp', pattern: /^[1][0-9][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'},
        // { validator: checkUserName, trigger: 'blur'}
    ],
    loginName: [
        { required: true, message: '请输入登录账号', trigger: 'blur'}
    ],
    account: [
        { required: true, message: '请输入账号或社会信用代码', trigger: 'blur'}
    ],
    password: [
        { required: true, message: '请输入密码', trigger: 'blur'}
    ],
    verificationCode:[{ required: true, message: '请输入验证码', trigger: 'blur'}],
    fpassword: [
        {required: true, message: '请输入登录密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
    ],
    fenPassword: [
        {required: true, message: '请再次输入登录密码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'}
    ],
    registerStatusName: [
        {required: true}
    ],
    supplierStatusName: [
        {required: true}
    ],
    companyName: [
        { required: true, message: '请输入企业名称', trigger: 'blur'}
    ],
    /* taxipayerStatus: [
        { required: true, message: ' ', trigger: 'change'}
    ], */
    // responser
   /* socialCreditCode:[
        {required: true, message: '必填项'},
        { validator: 'regexp',pattern: /^[0-9a-zA-Z]{18}$/,trigger: 'blur' }
        ],
    businessLicenseNumber:[
        {required: true, message: '必填项'},
        { validator: 'regexp',pattern: /^[a-zA-Z0-9]{13,15}$/,trigger: 'blur' }
        ],*/
    taxCertificateNumber:[
        {required: true, message: '请输入税务登记证号', trigger: 'blur'}
        ],
    orgCertificateNumber:[
        {required: true, message: '请输入组织机构代码证号', trigger: 'blur'}
        ],
    intentionRegionalCompanyIds:[
        {required: true, message: '请选择意向地区公司', trigger: 'change'}
    ],
    undertakeAreas: [
        {required: true, message: '请选择可承接省份', trigger: 'change'}
    ],
    supplierServiceCategoryIds:[
        {required: true, message: '请选择供方服务类别', trigger: 'change'}
    ],
    supplierCategoryIds:[
        {required: true, message: '请选择供方分类', trigger: 'change'}
    ],
    headquartersProvince:[
        {required: true, message: '请选择省', trigger: 'change'}
    ],
    headquartersCity:[
        {required: true, message: '请选择市', trigger: 'change'}
    ],
    headquartersAddress:[
        {required: true, message: '请输入总部具体地址', trigger: 'blur'}
    ],
    enterpriseCharacterize:[
        {required: true, message: '请选择企业性质', trigger: 'change'}
    ],
    enterpriseCharacterizeRemark:[
        {required: true, message: '请输入“其他”，相关说明', trigger: 'blur'}
    ],
    /* enterpriseRegistAddress:[
        {required: true, message: ' ', trigger: 'blur'}
    ], */
    enterpriseRegistrationYear:[
        {required: true, message: '请选择企业成立日期', trigger: 'change'},
    ],
    officeArea:[
        { required: false,validator: checkDeg, trigger: 'blur'},
        // {required: false,validator: 'regexp', pattern: /^\d*$/,message: '办公面积必须为数字值'}
        // {type: 'number', message: '办公面积必须为数字值'}
    ],
    legalRepresentative:[
        {required: true, message: ' ', trigger: 'blur'}
    ],
    legalRepresentativeIdNumber:[
        {required: false, message: '请输入法定代表人证件号码', trigger: 'blur'},
        {validator: 'regexp', pattern: /^[A-Za-z0-9]+$/,message: '证件号码格式不正确', trigger: 'blur'},
        // {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '证件号码格式不正确', trigger: 'blur'}
    ],
    registeredCapital:[
        {required: true, message: ' ', trigger: 'blur'},
        { validator: checkDeg2, trigger: 'blur'},
        // { type: 'number', message: '注册资本必须为数字值',trigger: 'blur'}
    ],
    /*北大招采新增*/
    masterAccountName:[
        {required: true, message: '请输入主账号管理员姓名', trigger: 'blur'}
    ],
    masterAccountMail:[
        {required: true, message: '请输入主账号管理员邮箱', trigger: 'blur'},
        { validator: 'regexp',pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,message:'邮箱格式不正确',trigger:'blur'}
    ],
    businessLicenseValidity:[
        {required: true, message: '请选择营业执照有效期', trigger: 'change'}
    ],
    isLongTermEffective:[
        {required: true, message: '请选择', trigger: 'change'}
    ],
    safetyProductionLicense:[
        {required: true, message: '请选择', trigger: 'change'}
    ],
    validityPeriodOfLicense:[
        {required: true, message: '请选择许可证有效期', trigger: 'change'}
    ],
    /*end*/
    qualificationNameLevel: [
        {required: true, message: '请输入资质名称及等级', trigger: 'blur'}
    ],
    certificateNumber:[
        {required: true, message: '请输入资质证书编号', trigger: 'blur'}
    ],
    validityPeriod:[
        {required: true, message: '请选择资质证书有效期', trigger: 'change'}
    ],
    stockholderName:[
        {required: true, message: '请输入股东姓名', trigger: 'blur'}
    ],
    stockholderCreditNumber:[
        {required: false, message: '请输入股东身份证号', trigger: 'blur'},
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确',trigger: 'blur'}
    ],
    tenderingAreaId:[
        {required: true, message: '请选择意向投标区域', trigger: 'blur'}
    ],
    contactPersonName:[
        {required: true, message: '请输入联系人姓名', trigger: 'blur'}
    ],
    contactPersonPhone:[
        {required: true, message: '请输入联系人电话', trigger: 'blur'}
    ],
    contactPersonMobile:[
        {required: true, message: '请输入联系人手机', trigger: 'blur'},
        { validator: 'regexp', pattern: /^[1][0-9][0-9]{9}$/, message: '手机号码格式不正确', trigger: 'blur'}
    ],
    contactPersonMail:[
        {required: true, message: '请输入联系人电子邮件', trigger: 'blur'},
        {validator: 'regexp',pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,message:'邮箱格式不正确',trigger:'blur'}
    ],
    contactPersonLicenceNumber:[
        {required: true, message: '请输入联系人身份证号', trigger: 'blur'},
        {validator: 'regexp', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '身份证号码格式不正确', trigger: 'blur'}
    ],
    contactPersonPosition:[
        {required: true, message: '请输入联系人职位', trigger: 'blur'}
    ],
    mainBusinessAreaIds:[
        {required: true, message: '请输入主要业务区域', trigger: 'blur'}
    ],
    lastYearSales:[
        {required: true, message: '请输入上年营业额', trigger: 'blur'},
        { validator: checkDeg, trigger: 'blur'},
        // { type: 'number', message: '营业额必须为数字值',trigger: 'blur'}
    ],
    fileList: [
        { required: true, message: '附件不能为空'}
    ],
    cooperationScale: [//合作额度
        { required: false,validator: checkDeg}
    ],
};
function checkUserName(rule,value,callback){
    axios.get(util.baseUrl+'/v1/sSuppliers/public/checkLoginName/'+value+'/1')
        .then(function (res) {
            // console.log(res);
            if(res.data.code == 1){
                callback();
            } else {
                callback(new Error(res.data.msg));
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}
function checkDeg(rule,value,callback){
    // console.log(value)
    // let reg = /^(-?\d+)(\.\d+)?$/;
    let reg = /^\d+(\.\d{1,2})?$/;
    if(!value){
        callback();
    } else if(!reg.test(value)) {
        callback(new Error('请输入数字，且小数点后不超过两位'));
    } else {
        callback();
    }
}
function checkDeg2(rule,value,callback){
  // console.log(value)
  // let reg = /^(-?\d+)(\.\d+)?$/;
  let reg = /^\d+(\.\d{1,6})?$/;
  if(!value){
      callback();
  } else if(!reg.test(value)) {
      callback(new Error('请输入数字，且小数点后不超过六位'));
  } else {
      callback();
  }
}
/*function checkSocialCode(rule,value,callback){

    axios.post(util.baseUrl+'/v1/sSuppliers/public/checkCodeOrNumber',{
        "businessLicenseNumber": "",
        "creditLicenseCodeFlag": 1,
        "socialCreditCode": value,
        "supplierId": ''
    })
        .then(function (res) {
            console.log(res);
            if(res.data.code == 2){
                callback();
            } else {
                callback(new Error(res.data.msg));
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}*/
let supplierTypeRules = {};//新增供应商 供方分类
__rules_generator(supplierTypeRules, ['categoryName','levelName','linkMan','linkManPhone'], rules)
let registerRules = {}//注册页面注册信息及企业信息验证 'userName',
__rules_generator(registerRules, ['verificationCode','fpassword','fenPassword','taxipayerStatus','taxCertificateNumber','orgCertificateNumber','intentionRegionalCompanyIds','supplierServiceCategoryIds','supplierCategoryIds','headquartersProvince','headquartersCity','headquartersAddress','enterpriseCharacterize','enterpriseCharacterizeRemark','enterpriseRegistAddress','enterpriseRegistrationYear','officeArea','legalRepresentative','legalRepresentativeIdNumber','registeredCapital','registerStatusName','supplierStatusName','undertakeAreas','businessLicenseValidity','isLongTermEffective','safetyProductionLicense','validityPeriodOfLicense','masterAccountName','masterAccountMail'], rules)
let naturalRules = {}//资质等级验证
__rules_generator(naturalRules, ['qualificationNameLevel','certificateNumber','validityPeriod'], rules)
let contactRules = {}//意向投标区域联系方式验证 'contactPersonMobile',
__rules_generator(contactRules, ['tenderingAreaId','contactPersonName','contactPersonMail','contactPersonLicenceNumber','contactPersonPosition','contactPersonPhone'], rules)
let businessRules = {}//业务状况验证
__rules_generator(businessRules, ['mainBusinessAreaIds','lastYearSales'], rules)
let numberRules = {}//区域业绩验证
__rules_generator(numberRules, ['cooperationScale'], rules)
let annexRules = {}//附件清單
__rules_generator(annexRules, ['fileList'], rules)
let loginRules = {};//登录界面验证
__rules_generator(loginRules, ['password','account'], rules)
let bankFormRules = {};//新增供应商 银行信息
__rules_generator(bankFormRules, ['country','accountName','bankAccount','openBank'], rules)
let lastThreeAchieveRules = {};//新增供应商 近三年业绩
__rules_generator(lastThreeAchieveRules, ['projectName','contractAmount','projectAddress','contractSupplierName'], rules)
let lastThreeFinanceRules = {};//新增供应商 近三年财务情况
__rules_generator(lastThreeFinanceRules, ['year','revenue','attachmentVOList'], rules)
let registerRules1 = {};//新增供应商 注册信息
__rules_generator(registerRules1, ['legalRepresentative','registeredCapital','enterpriseNature','businessLicenseValidity','businessLicenseStart','invoiceType','taxNumber','enterpriseRegistAddress','invoiceTaxRateList','taxipayerStatus','businessScope'], rules)
let baseRules = {};//新增供应商 基础信息
__rules_generator(baseRules, ['socialCreditCode','linkMan','linkManPost','linkPhone','recommender','headquartersAddress','companyEmail'], rules)
let resetPasswordRules = {};//账号密码修改
__rules_generator(resetPasswordRules, ['account','passwordNew','resetPasswordNew'], rules)

export {
    baseRules,
    registerRules,
    registerRules1,
    naturalRules,
    contactRules,
    businessRules,
    numberRules,
    annexRules,
    loginRules,
    supplierTypeRules,
    bankFormRules,
    lastThreeAchieveRules,
    lastThreeFinanceRules,
    resetPasswordRules,
}

function __rules_generator(obj, keys, rules){
    keys.forEach(k=>{
        return obj[k] = rules[k]
    })
}



// WEBPACK FOOTER //
// ./src/util/rules.js